import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
export function PainMirror() {
  return <>
      <Section alternate className="relative overflow-hidden" data-id="element-191">
        {/* Decorative element */}
        <div className="absolute left-0 top-20 bottom-20 w-[1px] bg-gradient-to-b from-transparent via-[#c9a04e]/30 to-transparent hidden md:block" data-id="element-192"></div>

        <div className="space-y-8 pl-0 md:pl-8 border-l-0 md:border-l border-[#c9a04e]/20" data-id="element-193">
          <h2 className="text-3xl md:text-4xl text-[#f5f0e8] mb-8" data-id="element-194">
            Esto es lo que nadie te dice del "insomnio" de mente acelerada
          </h2>

          <div className="space-y-6 text-lg text-[#f5f0e8]/90 leading-relaxed" data-id="element-195">
            <p data-id="element-196">La mayoría de noches no estás "sin sueño".</p>
            <p className="text-xl text-[#c9a04e]" data-id="element-197">Estás sin cierre.</p>
            <p data-id="element-198">
              Tu cuerpo pide cama.
              <br data-id="element-199" />
              Tu cerebro pide control.
            </p>
            <p data-id="element-200">
              Y como durante el día fuiste capaz de tirar…
              <br data-id="element-201" />
              por la noche tu cerebro se cobra la factura.
            </p>
            <p data-id="element-202">No porque seas débil.</p>
            <p data-id="element-203">
              Porque es el primer momento del día donde ya no hay ruido para
              taparlo.
            </p>
          </div>
        </div>
      </Section>

      {/* Image - person struggling to sleep */}
      <div className="relative w-full overflow-hidden" data-id="element-204">
        <motion.img src="https://cdn.magicpatterns.com/uploads/r5YFDu6VczpYzid3U78nhh/foto2-salesletter.png" alt="Mujer agotada sentada en la cama sin poder dormir" className="w-full object-cover object-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} data-id="element-205" />
        <div className="absolute inset-0 bg-[#1a2332]/40" data-id="element-206" />
        <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#1e2d3d] to-transparent" data-id="element-207" />
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#1a2332] to-transparent" data-id="element-208" />
      </div>
    </>;
}